import { ProductTagJson } from "@/types/Product.type";

export default function ProductDescriptionsTags({
	tags,
}: {
	tags: ProductTagJson[];
}) {
	const data = tags.filter((tag) => tag.type === "PRODUCT PERFAMER");
	let names: string[] = [];

	data.forEach((item) => {
		if (names.includes(item.name)) {
			return;
		}
		names.push(item.name);
	});

	if (data.length) {
		return (
			<>
				{names.map((title, index) => {
					return (
						<li key={index} className="flex items-center mb-[10px] ">
							<p className="min-w-[160px] font-bold   text-gray-400 text-base">
								{" "}
								{title}
							</p>
							<p className=" text-gray-500 text-base">
								{" "}
								{data
									.filter((item) => item.name === title)
									.map((item) => item.value)
									.join(", ")}
							</p>
						</li>
					);
				})}
			</>
		);
	}
}
